import { Action } from '@ngrx/store';
import { CARACTERIZACAO_INIT_TABLE } from '../mock';
import { Caracterizacao } from '../types/caracterizacao.types';

export enum CaracterizacaoActionTypes {
  LOAD_CARACTERIZACAO_SUCCESS = '[Caracterizacao] Load Caracterizacao Success',
  LOAD_CARACTERIZACAO_TABLE = '[Caracterizacao] Load Caracterizacao Table',
  LOAD_CARACTERIZACAO_SERVICE_MODAL = '[Caracterizacao] Load Caracterizacao Service Modal',
  LOAD_CARACTERIZACAO_FAILURE = '[Caracterizacao] Load Caracterizacao Failure',
  LOAD_CARACTERIZACAO_CLEAR = '[Caracterizacao] Load Caracterizacao Clear',
}

export class LoadCaracterizacaoSuccess implements Action {
  readonly type = CaracterizacaoActionTypes.LOAD_CARACTERIZACAO_SUCCESS;
  constructor(public payload: Caracterizacao) {}
}
export class LoadCaracterizacaoTable implements Action {
  readonly type = CaracterizacaoActionTypes.LOAD_CARACTERIZACAO_TABLE;
  constructor(public payload: typeof CARACTERIZACAO_INIT_TABLE) {}
}

export class LoadCaracterizacaoFailure implements Action {
  readonly type = CaracterizacaoActionTypes.LOAD_CARACTERIZACAO_FAILURE;
  constructor(public payload: { error: string }) {}
}

export class LoadCaracterizacaoClear implements Action {
  readonly type = CaracterizacaoActionTypes.LOAD_CARACTERIZACAO_CLEAR;
  constructor() {}
}

export type CaracterizacaoActions =
  | LoadCaracterizacaoSuccess
  | LoadCaracterizacaoTable
  | LoadCaracterizacaoFailure
  | LoadCaracterizacaoClear;
